module.exports = __webpack_public_path__ + "fonts/NeuePlakTextBold_normal_normal.18da801.woff";